import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Header() {
const [toggle , setToggle] = useState(false);

  const enableToggle = () => {
    setToggle(prev => !prev);
  };
  return (
    <>
     <div className={ toggle ? "th-menu-wrapper th-body-visible":"th-menu-wrapper"}>
    <div className="th-menu-area text-center">
      <button className="th-menu-toggle" onClick={enableToggle}>
        <i className="fal fa-times" />
      </button>
      <div className="mobile-logo">
        <a className="icon-masking" href="/">
          <span data-mask-src="assets/img/logo/logo.webp" className="mask-icon" />
          <img src="assets/img/logo/logo.webp" alt="Ride2luxury" />
        </a>
      </div>
      <div className="th-mobile-menu">
        <ul>
          <li>
            <a href="/">Home</a>
          </li>
          <li>
            <a href="/Vehicles">Vehicle</a>
          </li>
          <li>
            <a href="about.html">Services</a>
          </li>
          <li>
            <a href="about.html">Blog</a>
          </li>
          <li>
            <a href="about.html">About Us</a>
          </li>
          <li>
            <a href="about.html">Contact</a>
          </li>
          <li>
            <a href="about.html">Contact</a>
          </li>
        </ul>
        <br />
        <br />
        <div className="col-auto">
          <div className="header-button">
            <a href="ride2luxury.com" className="th-btn style-radius">
              Download App
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <header className="th-header header-layout15">
    <div className="header-top">
      <div className="container th-container4">
        <div className="row justify-content-center justify-content-lg-between align-items-center">
          <div className="col-auto d-none d-md-block">
            <div className="header-links">
              <ul>
                <li>
                  <i className="fa-regular fa-phone" />
                  <a href="tel:+918318754257">(+91) 8318754257 </a>
                </li>
                <li className="d-none d-xl-inline-block">
                  <i className="fa-sharp fa-regular fa-location-dot" />
                  <span>Head Office Gorakhpur Up India</span>
                </li>
                <li>
                  <i className="fa-regular fa-envelope" />
                  <a href="mailto:help@webteck.com">help@ride2luxury.com</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-auto">
            <div className="social-links">
              <span className="social-title">Follow Us On:</span>{" "}
              <a href="https://www.facebook.com/">
                <i className="fab fa-facebook-f" />
              </a>{" "}
              <a href="https://www.twitter.com/">
                <i className="fab fa-twitter" />
              </a>{" "}
              <a href="https://www.linkedin.com/">
                <i className="fab fa-linkedin-in" />
              </a>{" "}
              <a href="https://www.instagram.com/">
                <i className="fab fa-instagram" />
              </a>{" "}
              <a href="https://www.youtube.com/">
                <i className="fab fa-youtube" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="sticky-wrapper">
      <div className="menu-area">
        <div className="container th-container4">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="header-logo">
                <a className="icon-masking" href="/">
                  <span
                    data-mask-src="assets/img/logo/logo.webp" width={60} 
                    className="mask-icon"
                  />
                  <img src="assets/img/logo/logo.webp" alt="Ride2luxury" width={60} />
                </a>
              </div>
            </div>
            <div className="col-auto">
              <nav className="main-menu style2 d-none d-lg-inline-block">
                <ul>
                  <li className="menu-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="menu-item">
                    <a href="/Vehicles">Vehicle</a>
                  </li>
                  <li className="menu-item">
                    <a href="#">Services</a>
                  </li>
                  <li className="menu-item">
                    <a href="#">Blogs</a>
                  </li>
                  <li>
                    <a href="about.html">About Us</a>
                  </li>
                  <li>
                    <a href="contact.html">Contact</a>
                  </li>
                  <li>
                    <a href="Login.html">Login</a>
                  </li>
                </ul>
              </nav>
              <button  type="button"  className="th-menu-toggle d-block d-lg-none" onClick={enableToggle}>
                <i className="far fa-bars" />
              </button>
            </div>
            <div className="col-auto d-xl-block d-none">
              <div className="header-button">
                <a href="ride2luxury.com" className="th-btn style-radius">
                  Download App
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</>

  );
}

export default Header;
